import {
  GET_TEAM_UNAVAILABILITY,
  GET_TEAM_UNAVAILABILITY_SUCCESS,
  GET_TEAM_UNAVAILABILITY_FAIL,
  ADD_TEAM_UNAVAILABILITY,
  ADD_TEAM_UNAVAILABILITY_SUCCESS,
  ADD_TEAM_UNAVAILABILITY_FAIL,
  UPDATE_TEAM_UNAVAILABILITY,
  UPDATE_TEAM_UNAVAILABILITY_SUCCESS,
  UPDATE_TEAM_UNAVAILABILITY_FAIL,
  DELETE_TEAM_UNAVAILABILITY,
  DELETE_TEAM_UNAVAILABILITY_SUCCESS,
  DELETE_TEAM_UNAVAILABILITY_FAIL,
  SET_TEAM_UNAVAILABILITY_FIELD_ERRORS,
} from './actionTypes'

const initialState = {
  teamUnavailability: [],
  loading: false,
  error: null,
  status: null,
  fieldErrors: {}, // Store field-specific errors
}

const teamUnavailabilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TEAM_UNAVAILABILITY:
      return { ...state, loading: true }
    case GET_TEAM_UNAVAILABILITY_SUCCESS:
      return { ...state, loading: false, teamUnavailability: action.payload }
    case GET_TEAM_UNAVAILABILITY_FAIL:
      return { ...state, loading: false, error: action.payload }

    case ADD_TEAM_UNAVAILABILITY:
      return { ...state, loading: true }
    case ADD_TEAM_UNAVAILABILITY_SUCCESS:
      return { ...state, loading: false, status: 'success', fieldErrors: {} } // Clear field errors on success
    case ADD_TEAM_UNAVAILABILITY_FAIL:
      return { ...state, loading: false, error: action.payload }

    case UPDATE_TEAM_UNAVAILABILITY:
      return { ...state, loading: true }
    case UPDATE_TEAM_UNAVAILABILITY_SUCCESS:
      return {
        ...state,
        loading: false,
        fieldErrors: {}, // Clear field errors on success
      }
    case UPDATE_TEAM_UNAVAILABILITY_FAIL:
      return { ...state, loading: false, error: action.payload }

    case DELETE_TEAM_UNAVAILABILITY:
      return { ...state, loading: true }
    case DELETE_TEAM_UNAVAILABILITY_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case DELETE_TEAM_UNAVAILABILITY_FAIL:
      return { ...state, loading: false, error: action.payload }

    case SET_TEAM_UNAVAILABILITY_FIELD_ERRORS:
      return { ...state, fieldErrors: action.payload }

    default:
      return state
  }
}

export default teamUnavailabilityReducer
